/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Timesavailable1Inputs */

const de__field_timesavailable1 = /** @type {(inputs: _Field_Timesavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Verfügbarkeit`)
};

/**

* @param {_Field_Timesavailable1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_timesavailable1 = /** @type {((inputs?: _Field_Timesavailable1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Timesavailable1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_timesavailable1(inputs)
});
export { _field_timesavailable1 as "_field_timesAvailable" }